import React from "react";

export const FullWidthButton = ({
  label,
  children,
  color = "white",
  disabled = false,
  onClick,
  ...restProps
}) => {
  return (
    <button
      className={`full-width-btn btn-${color}-primary`}
      onClick={onClick}
      disabled={disabled}
      {...restProps}
    >
      {label || children}
    </button>
  );
};



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/components/Shared/FullWidthButton.js